export const translations = {
  de: {
    language_de: 'DE',
    language_en: 'EN',

    portal_title: 'Verifizierungsportal',
    portal_home_subtitle: 'Willkommen im Verifizierungsportal für Ihre virtuelle Geschäftsadresse in Deutschland.',
    portal_home_info: 'Wenn Sie eine Verifizierungsanfrage erhalten haben, öffnen Sie bitte den Link aus Ihrer E-Mail. Darüber gelangen Sie direkt zu Ihrer Verifizierung oder zu Ihrem persönlichen sicheren Upload-Link für fehlende Unterlagen.',

    verify_subtitle: 'Bitte füllen Sie das Formular aus und laden Sie die erforderlichen Unterlagen hoch.',
    account_prompt_title: 'Business Hub einrichten',
    account_prompt_text: 'Im Business Hub verwalten Sie Ihre Verifizierung, Nachforderungen, Zusatzleistungen sowie Briefkasten & Logo zentral. Die Verifizierung ist weiterhin auch ohne Business Hub m\u00f6glich.',
    account_prompt_button: 'Business Hub einrichten',
    account_prompt_existing_button: 'Im Business Hub einloggen',
    account_prompt_continue: 'Ohne Business Hub fortfahren',
    portal_upload_title: 'Unterlagen nachreichen',
    portal_upload_subtitle: 'Hier sehen Sie den aktuellen Stand Ihrer Verifizierung und können bei Bedarf weitere Unterlagen sicher hochladen.',

    loading: 'Lade...',
    error_load_verification: 'Fehler beim Laden der Verifizierung',
    error_loading: 'Fehler beim Laden',
    error_generic: 'Es ist ein Fehler aufgetreten.',
    error_fetch: 'Fehler beim Abruf',
    error_upload: 'Fehler beim Upload',

    identity_status: 'Identitätsstatus',
    business_status: 'Unternehmensstatus',
    status_before_submission_note: 'Diese Statusanzeige zeigt den bisherigen Prüfstand vor dieser Übermittlung. Ihre neue Auswahl und neue Dokumente werden mit „Unterlagen übermitteln“ gespeichert und anschließend geprüft.',

    already_submitted_title: 'Verifizierung bereits eingereicht',
    use_upload_link_title: 'Bitte sicheren Upload-Link nutzen',
    use_upload_link_text: 'Dieser Link ist nicht mehr für eine neue Erstverifizierung gedacht. Bitte nutzen Sie ab jetzt Ihren persönlichen sicheren Upload-Link für Status, Nachforderungen und spätere Nachreichungen.',
    currently_requested: 'Aktuell angefordert:',
    note: 'Hinweis',
    upload_more: 'Unterlagen nachreichen',

    first_name: 'Vorname',
    last_name: 'Nachname',
    email: 'E-Mail',
    phone_optional: 'Telefon optional',
    birth_date: 'Geburtsdatum',
    street: 'Straße und Hausnummer',
    postal_code: 'PLZ',
    city: 'Ort',
    country: 'Land',

    customer_type: 'Ich nutze den Service als',
    private_person: 'Privatperson',
    existing_company: 'Bestehendes Unternehmen',
    freelancer: 'Freelancer / Freiberuflich',
    sole_proprietor: 'Einzelunternehmen / Gewerbe',
    german_corporation: 'Deutsche Kapitalgesellschaft',
    association: 'Verein / eingetragener Verein (e. V.)',
    association_status_registered: 'Eingetragener Verein (e. V.)',
    association_status_registration_pending: 'Verein gegründet, Eintragung beantragt',
    association_status_unregistered: 'Verein gegründet, keine Eintragung vorgesehen',
    association_status_planned: 'Vereinsgründung noch nicht erfolgt',
    association_purpose: 'Vereinszweck',
    association_name: 'Name beziehungsweise vorgesehener Name des Vereins',
    association_representative: 'Auftretende Person: Name, Funktion und Vertretungsart',
    association_current_street: 'Aktuelle Anschrift des Vereins: Straße und Hausnummer',
    association_current_postal_code: 'Vereinsanschrift: PLZ',
    association_current_city: 'Vereinsanschrift: Ort',
    association_current_country: 'Vereinsanschrift: Land',
    association_register_court: 'Registergericht',
    association_register_court_optional: 'Vorgesehenes Registergericht, falls bekannt',
    association_register_number: 'Vereinsregisternummer (VR)',
    association_file_reference_optional: 'Aktenzeichen, falls vorhanden',
    association_foundation_date: 'Gründungsdatum',
    association_planned_foundation_date: 'Geplantes Gründungsdatum',
    foreign_company: 'Ausländisches / nicht-deutsches Gewerbe oder Unternehmen',
    planned_founding: 'Gründung geplant',

    company_name: 'Firmenname',
    planned_company_name: 'Geplanter Firmenname',
    planned_company_name_optional: 'Geplanter Firmenname optional',
    company_name_or_planned: 'Firmenname / geplanter Firmenname',
    business_designation_optional: 'Geschäftsbezeichnung / Markenname optional',
    trade_name_optional: 'Geschäftsname / Gewerbebezeichnung optional',
    foreign_company_name: 'Unternehmensname',
    legal_form: 'Rechtsform',
    legal_form_foreign_optional: 'Rechtsform / Unternehmensform',
    legal_form_placeholder: 'z. B. Einzelunternehmen, UG, GmbH',
    foreign_legal_form_placeholder: 'z. B. LLC, Limited, SARL, Inc., OÜ',
    representative: 'Vertreter / Inhaber / Geschäftsführer',
    representative_optional: 'Vertreter / Inhaber / Geschäftsführer (optional)',
    business_activity: 'Tätigkeit / Branche',
    business_activity_optional: 'Tätigkeit / Branche (optional)',
    activity_optional: 'Tätigkeitsbezeichnung / Branche optional',
    company_country: 'Unternehmensland',
    please_select: 'Bitte auswählen',

    company_street_optional: 'Unternehmensstraße, falls abweichend',
    company_postal_code_optional: 'Unternehmens-PLZ, falls abweichend',
    company_city_optional: 'Unternehmensort, falls abweichend',
    company_country_optional: 'Unternehmensland, falls abweichend',
    register_court_optional: 'Registergericht, falls vorhanden',
    register_number_optional: 'Registernummer, falls vorhanden',
    tax_number_optional: 'Steuernummer, optional',
    vat_id_optional: 'USt-ID, optional',
    planned_foundation_date_optional: 'Geplantes Gründungsdatum, optional',

    id_front: 'Ausweis Vorderseite',
    id_back: 'Ausweis Rückseite',
    selfie: 'Selfie',
    freelancer_proof: 'Nachweis der freiberuflichen Tätigkeit',
    business_doc_full: 'Gewerbeanmeldung / Handelsregister / Vollmacht',
    business_doc: 'Unternehmensdokument',
    trade_registration: 'Gewerbeanmeldung',
    commercial_register_extract: 'Handelsregisterauszug',
    commercial_register_extract_or_proof: 'Handelsregisterauszug oder vergleichbarer Nachweis',
    association_register_extract_or_proof: 'Vereinsregisterauszug oder vergleichbarer Vereinsnachweis',
    association_register_extract: 'Aktueller Vereinsregisterauszug',
    association_statutes: 'Aktuelle Satzung',
    association_draft_statutes: 'Satzungsentwurf',
    association_founding_and_board_protocol: 'Gründungsprotokoll und Nachweis der Vorstandswahl (gemeinsam als eine Datei)',
    association_statutes_optional: 'Aktuelle Satzung (optional)',
    foreign_business_proof: 'Unternehmensnachweis / Registerauszug / Gewerbenachweis',
    power_of_attorney: 'Vollmacht',
    extra_doc: 'Zusatzdokument',
    extra_doc_optional: 'Zusatzdokument (optional)',
    delete_this_document: 'Dieses Dokument löschen',
    replace_document_hint: 'Zum Ändern einfach eine neue Datei hochladen. Ohne Upload bleibt das vorhandene Dokument erhalten.',
    document_kept: 'Vorhandenes Dokument bleibt erhalten',
    document_will_be_replaced: 'Vorhandenes Dokument wird ersetzt',
    document_marked_for_removal: 'Vorhandenes Dokument ist zum Entfernen vorgemerkt',
    document_saved: 'Dokument gespeichert',
    new_document: 'Neue Datei',
    document_replace_explanation: 'Beim Übermitteln wird ausschließlich die oben genannte neue Datei gespeichert.',
    document_removal_explanation: 'Beim Übermitteln wird dieses Dokument entfernt. Ohne Ersatzdatei kann ein Pflichtnachweis fehlen.',
    remove_existing_document: 'Vorhandenes Dokument entfernen',
    undo_document_removal: 'Entfernen rückgängig machen',

    freelancer_hint_text: 'Sie können Tätigkeit und Geschäftsbezeichnung optional angeben. Ein Firmenname oder eine Rechtsform ist für Freelancer nicht erforderlich.',
    planned_founding_hint_text: 'Für eine geplante Gründung ist beim ersten Schritt noch kein Unternehmensdokument erforderlich. Sie können fehlende Unterlagen später über einen persönlichen sicheren Upload-Link nachreichen.',

    submit_documents: 'Unterlagen übermitteln',
    submitting: 'Wird übermittelt...',
    submitted_successfully: 'Erfolgreich übermittelt',
    submitted_summary_title: 'Diese Angaben wurden erfolgreich übermittelt:',
    submitted_as: 'Gewählte Nutzung',
    submitted_organization: 'Organisation',
    submitted_legal_form: 'Status / Rechtsform',
    submitted_representative: 'Auftretende Person',
    submitted_primary_document: 'Vereins- oder Unternehmensnachweis',
    submitted_additional_document: 'Zusätzliches Dokument',
    submitted_summary_hint: 'Die Dateien und Angaben sind gespeichert und werden nun geprüft. Änderungen erfolgen anschließend über den persönlichen sicheren Upload-Link.',
    upload_documents: 'Unterlagen hochladen',
    uploading: 'Wird hochgeladen...',

    submit_success: 'Vielen Dank. Ihre Unterlagen wurden erfolgreich übermittelt.',
    submit_success_founding: 'Vielen Dank. Ihre Unterlagen wurden erfolgreich übermittelt. Ihren persönlichen Upload-Link für spätere Unternehmensunterlagen haben wir Ihnen zusätzlich per E-Mail gesendet.',
    edit_mailbox_name: 'Briefkastennamen bearbeiten',
    edit_mailbox_name_hint: 'Im Business Hub können Sie den gewünschten Namen für die Briefkastenanzeige und optional ein Logo hinterlegen.',
    already_submitted_message: 'Diese Verifizierung wurde bereits übermittelt. Bitte nutzen Sie für weitere Unterlagen Ihren persönlichen Upload-Link.',

    status_new: 'Neu',
    status_new_desc: 'Ihr Fall wurde angelegt, es wurden aber noch keine Unterlagen eingereicht.',
    status_submitted: 'Eingereicht',
    identity_submitted_desc: 'Ihre Unterlagen wurden eingereicht und warten auf die weitere Bearbeitung.',
    status_in_review: 'In Prüfung',
    identity_in_review_desc: 'Ihre Identitätsunterlagen werden aktuell geprüft.',
    status_additional_requested: 'Nachforderung offen',
    identity_additional_requested_desc: 'Es werden weitere Identitätsunterlagen oder ergänzende Nachweise benötigt.',
    status_approved: 'Freigegeben',
    identity_approved_desc: 'Ihre Identität wurde erfolgreich geprüft und freigegeben.',
    status_rejected: 'Abgelehnt',
    identity_rejected_desc: 'Die eingereichten Unterlagen konnten leider nicht freigegeben werden.',
    identity_status_default_desc: 'Aktueller Status Ihrer Identitätsprüfung.',

    status_not_required: 'Nicht erforderlich',
    business_not_required_desc: 'Für diesen Fall werden aktuell keine zusätzlichen Unternehmensunterlagen benötigt.',
    status_pending: 'Ausstehend',
    business_pending_desc: 'Es werden noch Unternehmensunterlagen oder weitere Nachweise benötigt.',
    business_submitted_desc: 'Die Unternehmensunterlagen wurden eingereicht und werden geprüft.',
    business_in_review_desc: 'Ihre Unternehmensunterlagen werden aktuell geprüft.',
    business_approved_desc: 'Die Unternehmensunterlagen wurden erfolgreich freigegeben.',
    business_rejected_desc: 'Die eingereichten Unternehmensunterlagen konnten nicht freigegeben werden.',
    business_status_default_desc: 'Aktueller Status Ihrer Unternehmensunterlagen.',

    verification_complete: 'Ihre Verifizierung ist vollständig abgeschlossen. Vielen Dank.',
    followup_request: 'Nachforderung',
    please_submit_requested_documents: 'Bitte reichen Sie folgende Unterlagen nach:',
    founding_followup_title: 'Nachreichung für geplante Gründung',
    founding_followup_text: 'Ihre Identitätsprüfung wurde bereits eingereicht. Bitte reichen Sie jetzt die Unternehmensunterlagen nach, sobald diese vorliegen.',
    freelancer_missing_title: 'Nachweis der freiberuflichen Tätigkeit fehlt noch',
    freelancer_missing_text: 'Für Ihre freiberufliche Nutzung benötigen wir noch einen passenden Nachweis Ihrer Tätigkeit.',
    business_docs_missing_title: 'Unternehmensunterlagen fehlen noch',
    business_docs_missing_text: 'Für Ihr bestehendes Unternehmen benötigen wir noch die passenden Unternehmensunterlagen.',
    please_upload_documents_here: 'Bitte reichen Sie hier die angeforderten Unterlagen hoch.',
    check_agreement_data_title: 'Angaben für die Nutzungsvereinbarung prüfen',
    check_agreement_data_text: 'Falls sich Ihre Firmendaten seit der ersten Verifizierung geändert haben, aktualisieren Sie diese bitte hier. Die Nutzungsvereinbarung wird danach mit den neuen Angaben erzeugt.',

    logistics_loading: 'Ihre Versanddaten werden geladen...',
    logistics_error_load: 'Der Versandauftrag konnte nicht geladen werden.',
    logistics_error_save: 'Ihre Angaben konnten nicht gespeichert werden.',
    logistics_success_saved: 'Vielen Dank. Ihre Versanddaten wurden erfolgreich übermittelt.',
    logistics_complete_title: 'Versanddaten erfolgreich übermittelt',
    logistics_complete_text: 'Vielen Dank. Wir haben Ihre Angaben erhalten und bereiten die nächsten Schritte vor.',
    logistics_complete_close: 'Sie können diese Seite jetzt schließen.',
    logistics_title: 'Versand vorbereiten',
    logistics_subtitle: 'Teilen Sie uns mit, wohin wir Ihre Sendung weiterleiten dürfen. Der Versand erfolgt sicher per DHL mit Sendungsverfolgung.',
    logistics_order: 'Bestellung',
    logistics_service: 'Leistung',
    logistics_order_number: 'Bestellnummer',
    logistics_email: 'E-Mail',
    logistics_name: 'Name',
    logistics_company: 'Firma',
    logistics_billing_address: 'Rechnungsadresse',
    logistics_no_billing_address: 'Keine Rechnungsadresse vorhanden.',
    logistics_recipient_same_as_billing: 'Empf\u00e4ngeradresse entspricht Rechnungsadresse',
    logistics_recipient_name: 'Empf\u00e4ngername',
    logistics_recipient_company: 'Empf\u00e4ngerfirma',
    logistics_recipient_street: 'Stra\u00dfe und Hausnummer',
    logistics_address_extra: 'Adresszusatz',
    logistics_zip: 'PLZ',
    logistics_city: 'Ort',
    logistics_country: 'Land',
    logistics_phone: 'Telefonnummer f\u00fcr DHL-Zustellung',
    logistics_inbound_tracking: 'Sendungsnummer des eingehenden Pakets',
    logistics_inbound_carrier: 'Versanddienstleister des eingehenden Pakets',
    logistics_expected_arrival: 'Erwartetes Eingangsdatum bei uns',
    logistics_sender: 'Absender, falls bekannt',
    logistics_content_notes: 'Grobe Inhaltsbeschreibung',
    logistics_collective_dhl_notice: 'Wir versenden Ihre gesammelte Post ausschlie\u00dflich per DHL mit Sendungsverfolgung.',
    logistics_customer_notes: 'Hinweise für unser Versandteam',
    logistics_express_requested: 'Expressversand anfragen (optional; mögliche Mehrkosten bestätigen wir vorab)',
    logistics_accept_shipping_costs: 'Ich best\u00e4tige, dass Versandkosten separat bzw. 1:1 weiterberechnet werden.',
    logistics_accept_content_rules: 'Ich best\u00e4tige, dass keine verbotenen, gef\u00e4hrlichen oder ungeeigneten Inhalte versendet werden.',
    logistics_saving: 'Angaben werden übermittelt...',
    logistics_submit: 'Versanddaten verbindlich übermitteln',
    logistics_service_parcel: 'Paketweiterleitung',
    logistics_service_parcel_5kg: 'Paketweiterleitung bis 5 kg',
    logistics_service_parcel_10kg: 'Paketweiterleitung bis 10 kg',
    logistics_service_parcel_20kg: 'Paketweiterleitung bis 20 kg',
    logistics_service_collective: 'Gesammelte Post versenden',
    upload_success: 'Unterlagen wurden übermittelt.',
    upload_success_agreement_updated: 'Unterlagen wurden übermittelt und Ihre Angaben für die Nutzungsvereinbarung wurden aktualisiert.',
  },

  en: {
    language_de: 'DE',
    language_en: 'EN',

    portal_title: 'Verification Portal',
    portal_home_subtitle: 'Welcome to the verification portal for your virtual business address in Germany.',
    portal_home_info: 'If you have received a verification request, please open the link from your email. It will take you directly to your verification or to your personal secure upload link for missing documents.',

    verify_subtitle: 'Please fill out the form and upload the required documents.',
    account_prompt_title: 'Set up your Business Hub',
    account_prompt_text: 'Use the Business Hub to manage verification, additional requests, extra services, your mailbox display name and logo in one place. You can still complete verification without a Business Hub.',
    account_prompt_button: 'Set up Business Hub',
    account_prompt_existing_button: 'Log in to Business Hub',
    account_prompt_continue: 'Continue without Business Hub',
    portal_upload_title: 'Submit additional documents',
    portal_upload_subtitle: 'Here you can see the current status of your verification and securely upload additional documents if required.',

    loading: 'Loading...',
    error_load_verification: 'Error loading verification',
    error_loading: 'Error loading',
    error_generic: 'An error occurred.',
    error_fetch: 'Error loading data',
    error_upload: 'Error during upload',

    identity_status: 'Identity status',
    business_status: 'Business status',
    status_before_submission_note: 'This status shows the previous review state before this submission. Your new selection and documents are saved when you select “Submit documents” and are then reviewed.',

    already_submitted_title: 'Verification already submitted',
    use_upload_link_title: 'Please use your secure upload link',
    use_upload_link_text: 'This link is no longer intended for a new initial verification. Please use your personal secure upload link from now on for status updates, requests and later document submissions.',
    currently_requested: 'Currently requested:',
    note: 'Note',
    upload_more: 'Submit additional documents',

    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
    phone_optional: 'Phone optional',
    birth_date: 'Date of birth',
    street: 'Street and house number',
    postal_code: 'Postal code',
    city: 'City',
    country: 'Country',

    customer_type: 'I am using the service as',
    private_person: 'Private individual',
    existing_company: 'Existing company',
    freelancer: 'Freelancer / self-employed professional',
    sole_proprietor: 'Sole proprietor / trade business',
    german_corporation: 'German corporation',
    association: 'Association / registered association (e. V.)',
    association_status_registered: 'Registered association (e. V.)',
    association_status_registration_pending: 'Association formed, registration pending',
    association_status_unregistered: 'Association formed, no registration intended',
    association_status_planned: 'Association not yet formed',
    association_purpose: 'Purpose of the association',
    association_name: 'Name or intended name of the association',
    association_representative: 'Acting person: name, function and authority to represent',
    association_current_street: 'Current association address: street and house number',
    association_current_postal_code: 'Association address: postal code',
    association_current_city: 'Association address: city',
    association_current_country: 'Association address: country',
    association_register_court: 'Register court',
    association_register_court_optional: 'Intended register court, if known',
    association_register_number: 'Association register number (VR)',
    association_file_reference_optional: 'File reference, if available',
    association_foundation_date: 'Formation date',
    association_planned_foundation_date: 'Planned formation date',
    foreign_company: 'Foreign / non-German business or company',
    planned_founding: 'Planned company formation',

    company_name: 'Company name',
    planned_company_name: 'Planned company name',
    planned_company_name_optional: 'Planned company name optional',
    company_name_or_planned: 'Company name / planned company name',
    business_designation_optional: 'Business designation / brand name optional',
    trade_name_optional: 'Trade name / business designation optional',
    foreign_company_name: 'Company name',
    legal_form: 'Legal form',
    legal_form_foreign_optional: 'Legal form / company type',
    legal_form_placeholder: 'e.g. sole proprietorship, UG, GmbH',
    foreign_legal_form_placeholder: 'e.g. LLC, Limited, SARL, Inc., OÜ',
    representative: 'Representative / owner / managing director',
    representative_optional: 'Representative / owner / managing director (optional)',
    business_activity: 'Business activity / industry',
    business_activity_optional: 'Business activity / industry (optional)',
    activity_optional: 'Activity / industry optional',
    company_country: 'Company country',
    please_select: 'Please select',

    company_street_optional: 'Company street, if different',
    company_postal_code_optional: 'Company postal code, if different',
    company_city_optional: 'Company city, if different',
    company_country_optional: 'Company country, if different',
    register_court_optional: 'Register court, if available',
    register_number_optional: 'Register number, if available',
    tax_number_optional: 'Tax number, optional',
    vat_id_optional: 'VAT ID, optional',
    planned_foundation_date_optional: 'Planned formation date, optional',

    id_front: 'ID front side',
    id_back: 'ID back side',
    selfie: 'Selfie',
    freelancer_proof: 'Proof of freelance activity',
    business_doc_full: 'Trade registration / commercial register extract / power of attorney',
    business_doc: 'Business document',
    trade_registration: 'Trade registration',
    commercial_register_extract: 'Commercial register extract',
    commercial_register_extract_or_proof: 'Commercial register extract or comparable proof',
    association_register_extract_or_proof: 'Association register extract or comparable proof',
    association_register_extract: 'Current association register extract',
    association_statutes: 'Current statutes',
    association_draft_statutes: 'Draft statutes',
    association_founding_and_board_protocol: 'Formation minutes and proof of board election (combined in one file)',
    association_statutes_optional: 'Current statutes (optional)',
    foreign_business_proof: 'Company proof / register extract / trade proof',
    power_of_attorney: 'Power of attorney',
    extra_doc: 'Additional document',
    extra_doc_optional: 'Additional document (optional)',
    delete_this_document: 'Delete this document',
    replace_document_hint: 'Upload a new file to replace it. Without a new upload, the existing document will be kept.',
    document_kept: 'Existing document will be kept',
    document_will_be_replaced: 'Existing document will be replaced',
    document_marked_for_removal: 'Existing document is marked for removal',
    document_saved: 'Document saved',
    new_document: 'New file',
    document_replace_explanation: 'When submitted, only the new file named above will be stored.',
    document_removal_explanation: 'This document will be removed when submitted. Without a replacement, required evidence may be missing.',
    remove_existing_document: 'Remove existing document',
    undo_document_removal: 'Undo removal',

    freelancer_hint_text: 'Sie können Tätigkeit und Geschäftsbezeichnung optional angeben. Ein Firmenname oder eine Rechtsform ist für Freelancer nicht erforderlich.',
    planned_founding_hint_text: 'For a planned company formation, no business document is required in the first step. Missing documents can be submitted later via your personal secure upload link.',

    submit_documents: 'Submit documents',
    submitting: 'Submitting...',
    submitted_successfully: 'Submitted successfully',
    submitted_summary_title: 'The following information was submitted successfully:',
    submitted_as: 'Selected use',
    submitted_organization: 'Organisation',
    submitted_legal_form: 'Status / legal form',
    submitted_representative: 'Acting person',
    submitted_primary_document: 'Association or company evidence',
    submitted_additional_document: 'Additional document',
    submitted_summary_hint: 'The files and information have been saved and will now be reviewed. Further changes can be submitted through your personal secure upload link.',
    upload_documents: 'Upload documents',
    uploading: 'Uploading...',

    submit_success: 'Thank you. Your documents have been submitted successfully.',
    submit_success_founding: 'Thank you. Your documents have been submitted successfully. We have also sent your personal upload link for later business documents by email.',
    edit_mailbox_name: 'Edit mailbox display name',
    edit_mailbox_name_hint: 'In your Business Hub, you can set the desired mailbox display name and optionally upload a logo.',
    already_submitted_message: 'This verification has already been submitted. Please use your personal upload link for additional documents.',

    status_new: 'New',
    status_new_desc: 'Your case has been created, but no documents have been submitted yet.',
    status_submitted: 'Submitted',
    identity_submitted_desc: 'Your documents have been submitted and are waiting for further processing.',
    status_in_review: 'In review',
    identity_in_review_desc: 'Your identity documents are currently being reviewed.',
    status_additional_requested: 'Additional documents requested',
    identity_additional_requested_desc: 'Additional identity documents or supporting documents are required.',
    status_approved: 'Approved',
    identity_approved_desc: 'Your identity has been successfully reviewed and approved.',
    status_rejected: 'Rejected',
    identity_rejected_desc: 'Unfortunately, the submitted documents could not be approved.',
    identity_status_default_desc: 'Current status of your identity verification.',

    status_not_required: 'Not required',
    business_not_required_desc: 'No additional business documents are currently required for this case.',
    status_pending: 'Pending',
    business_pending_desc: 'Business documents or additional proof are still required.',
    business_submitted_desc: 'The business documents have been submitted and are being reviewed.',
    business_in_review_desc: 'Your business documents are currently being reviewed.',
    business_approved_desc: 'The business documents have been successfully approved.',
    business_rejected_desc: 'The submitted business documents could not be approved.',
    business_status_default_desc: 'Current status of your business documents.',

    verification_complete: 'Your verification has been fully completed. Thank you.',
    followup_request: 'Additional request',
    please_submit_requested_documents: 'Please submit the following documents:',
    founding_followup_title: 'Follow-up for planned company formation',
    founding_followup_text: 'Your identity verification has already been submitted. Please submit the business documents now as soon as they are available.',
    freelancer_missing_title: 'Proof of freelance activity still missing',
    freelancer_missing_text: 'For your freelance use, we still need suitable proof of your activity.',
    business_docs_missing_title: 'Business documents still missing',
    business_docs_missing_text: 'For your existing company, we still need the relevant business documents.',
    please_upload_documents_here: 'Please upload the requested documents here.',
    check_agreement_data_title: 'Check usage agreement details',
    check_agreement_data_text: 'If your company details have changed since the initial verification, please update them here. The usage agreement will then be generated with the new details.',

    logistics_loading: 'Loading your shipping details...',
    logistics_error_load: 'The forwarding request could not be loaded.',
    logistics_error_save: 'Your details could not be saved.',
    logistics_success_saved: 'Thank you. Your shipping details have been submitted successfully.',
    logistics_complete_title: 'Shipping details submitted',
    logistics_complete_text: 'Thank you. We have received your details and will prepare the next steps.',
    logistics_complete_close: 'You can close this page now.',
    logistics_title: 'Prepare your shipment',
    logistics_subtitle: 'Tell us where you would like your shipment sent. We use tracked DHL shipping for secure delivery.',
    logistics_order: 'Order',
    logistics_service: 'Service',
    logistics_order_number: 'Order number',
    logistics_email: 'Email',
    logistics_name: 'Name',
    logistics_company: 'Company',
    logistics_billing_address: 'Billing address',
    logistics_no_billing_address: 'No billing address available.',
    logistics_recipient_same_as_billing: 'Recipient address is the same as the billing address',
    logistics_recipient_name: 'Recipient name',
    logistics_recipient_company: 'Recipient company',
    logistics_recipient_street: 'Street and house number',
    logistics_address_extra: 'Address line 2',
    logistics_zip: 'Postal code',
    logistics_city: 'City',
    logistics_country: 'Country',
    logistics_phone: 'Phone number for DHL delivery',
    logistics_inbound_tracking: 'Tracking number of the incoming parcel',
    logistics_inbound_carrier: 'Carrier of the incoming parcel',
    logistics_expected_arrival: 'Expected arrival date at our location',
    logistics_sender: 'Sender, if known',
    logistics_content_notes: 'General content description',
    logistics_collective_dhl_notice: 'We ship your collected mail exclusively via DHL with tracking.',
    logistics_customer_notes: 'Notes for our shipping team',
    logistics_express_requested: 'Request express shipping (optional; we will confirm any additional cost in advance)',
    logistics_accept_shipping_costs: 'I confirm that shipping costs will be charged separately and passed on 1:1.',
    logistics_accept_content_rules: 'I confirm that no prohibited, dangerous or unsuitable contents will be shipped.',
    logistics_saving: 'Submitting details...',
    logistics_submit: 'Submit shipping details',
    logistics_service_parcel: 'Parcel forwarding',
    logistics_service_parcel_5kg: 'Parcel forwarding up to 5 kg',
    logistics_service_parcel_10kg: 'Parcel forwarding up to 10 kg',
    logistics_service_parcel_20kg: 'Parcel forwarding up to 20 kg',
    logistics_service_collective: 'Forward collected mail',
    upload_success: 'Documents have been submitted.',
    upload_success_agreement_updated: 'Documents have been submitted and your details for the usage agreement have been updated.',
  },
};

export const getLang = () => {
  if (typeof window === 'undefined') {
    return 'de';
  }

  const requestedLang = new URLSearchParams(window.location.search).get('lang');
  if (['de', 'en'].includes(requestedLang)) {
    return requestedLang;
  }

  return localStorage.getItem('lang') || 'de';
};

export const setLang = (lang) => {
  if (!['de', 'en'].includes(lang)) {
    return;
  }

  localStorage.setItem('lang', lang);
  window.location.reload();
};

export const t = (key) => {
  const lang = getLang();
  return translations[lang]?.[key] || translations.de[key] || key;
};

export const statusLabel = (status) => {
  const normalized = String(status || '').toLowerCase();

  const map = {
    new: t('status_new'),
    submitted: t('status_submitted'),
    in_review: t('status_in_review'),
    additional_requested: t('status_additional_requested'),
    approved: t('status_approved'),
    rejected: t('status_rejected'),
    not_required: t('status_not_required'),
    pending: t('status_pending'),
  };

  return map[normalized] || status || '-';
};

